import React from 'react'
import Web3 from 'web3'
import styled from 'styled-components';
import ProgressImg from '../../assets/img/progress.png'
import {useStakingInfo} from "../../hooks";
import BigNumber from "bignumber.js";

const ProgressBoxStyle = styled.div`
  width: 100%;
  min-height: 200px;
  background-color: #fff;
  border-radius: 12px 0px 0px 12px;
  box-shadow: 6px 6px 19px -3px rgba(13, 64, 152, 0.16);
  padding: 20px;
  flex-basis: 100%;
  color: #2A2D35;
  margin-top: 20px;
  font-weight: 500;
  font-size: 20px;
  &:hover {
    box-shadow: 6px 6px 19px -3px rgba(29, 38, 54, 0.25);
  }
  >h3 {
    color: #2A2D35;
  }
  .real-number {
    margin: 10px 0;
    >span:last-child {
      font-size: 16px;
      margin-left: 8px;
    }
  }
  .progress-box {
    border-radius: 3px;
    border: 1px solid #229F20;
    height: 40px;
    padding: 5px;
    .pro-box {
      height: 100%;
      border-radius: 3px;
      background: url(${ProgressImg}) no-repeat;
      background-position: center;
      background-size: cover;
      display: flex;
      flex-direction: row-reverse;
      .pro-line {
        height:100%;
        background: rgba(255,255,255,.6)
      }
    }
  }
  .all-number {
    display: flex;
    justify-content: space-between;
    color: #7D8A96;
    margin: 10px 0;
    font-size: 16px;
    .mtr6 {
      margin-right: 6px;
    }
  }
`;

export default function ProgressBox(props) {
  // const [right, setRight] = useState(0);

  // useEffect(()=>{
  //   const right = (document.body.offsetWidth - maxWidth ) /2 ;
  //   if (right>0) setRight(right);
  // }, []);

  const stakingInfo = useStakingInfo()
  const {fromWei} = Web3.utils

  const progress = (stakingInfo.top && stakingInfo.total) ? new BigNumber(stakingInfo.total).dividedBy(stakingInfo.top).multipliedBy(100) : 0;
  const this_progress = (100 - progress);

  return (
    <ProgressBoxStyle>
      <h3>Real-time Grant Progress</h3>
      <div className="real-number">
        <span>{stakingInfo.total? fromWei(stakingInfo.total): '-'}</span>
        <span>TRIAS</span>
      </div>
      <div className="progress-box">
        <div className="pro-box">
          <div className="pro-line" style={{width: this_progress + '%'}} title={progress+'%'}/>
        </div>
      </div>
      <div className="all-number">
        <div>
          <span className="mtr6">0</span>
          <span>TRIAS</span>
        </div>
        <div>
          <span className="mtr6">{stakingInfo.top? fromWei(stakingInfo.top): '-'}</span>
          <span>TRIAS</span>
        </div>
      </div>
    </ProgressBoxStyle>
  )
}
